import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT } from "const"
import {
    PRM_ACCOUNT_SETTINGS,
    StoreType,
    ChangeAccountSettings,
    updateAccountSettings,
} from "client/store"
import { hasAccess } from "client/utils"
import {
    FormGroup,
    Label,
    CKEditor,
} from "client/components"


const DefaultAccountSettings = () => {
    const settings = useSelector((state: StoreType) => state.accountSettings.settings.sil)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const onChange = (value: ChangeAccountSettings) => {
        dispatch(updateAccountSettings("sil", value))
    }

    const { defaultAssumption } = settings
    const editAccess = hasAccess(PRM_ACCOUNT_SETTINGS, EDIT)

    return (
        <FormGroup>
            <Label>{lang.defaultAssumption}</Label>
            <CKEditor
                data={defaultAssumption}
                isReadOnly={!editAccess}
                onChange={(data) => onChange({ defaultAssumption: data })}
            />
        </FormGroup>
    )
}
export default DefaultAccountSettings
